import React from "react";
import { BrowserRouter } from "react-router";
import "./App.css";
import { AuthProvider } from "./context/Auth0Context";
import { SideMenuProvider } from "./context/SideMenuContext";
import { QueryProvider } from "./providers/QueryProvider";
import AppRouter from "./router/AppRouter";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <QueryProvider>
        <AuthProvider>
          <SideMenuProvider>
            <AppRouter />
          </SideMenuProvider>
        </AuthProvider>
      </QueryProvider>
    </BrowserRouter>
  );
};

export default App;
